import UploadTable from './UploadTable.vue';

export default UploadTable;
